export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            了解555影视背后的故事与初心
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="flex items-center gap-3 mb-6 justify-center">
            <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-bold text-xl font-heading">
              555
            </span>
            <span className="text-2xl font-heading text-foreground-900">555影视</span>
          </div>
          <div className="space-y-4 text-foreground-600 text-sm leading-relaxed">
            <p>
              555影视诞生于一群电影爱好者的共同愿景——让每一个人都能轻松享受最新电影、高清电影带来的视听盛宴。我们深知影迷对画质和播放流畅度的苛刻要求，因此始终坚持以高清片源为基础，以流畅不缓冲为核心体验目标。
            </p>
            <p>
              平台汇聚超过20000部电影资源，覆盖动作、喜剧、科幻、悬疑、动画等全类型，从最新上映的热门大片到经典影史佳作一应俱全。每日同步更新，确保您总能在第一时间看到想看的好电影。
            </p>
            <p>
              555影视坚持免费在线观看模式，无需注册、无需付费。我们相信好的电影应该被更多人看到。无论是通勤途中的碎片时间，还是周末午后的悠闲时光，打开555影视，随时随地开启您的免费观影之旅。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}